<template>
  <div class="analytic-editor">
    <pre class="expression">Predicate: {{ expression }}</pre>
    <query-builder-group
    :index=0
    :depth=1
    :fieldPrepend="''"
    :def="def"
    :expression.sync="expression">
    </query-builder-group>
  </div>
</template>

<script>
import QueryBuilderGroup from './QueryBuilderGroup.vue';

export default {
  name: 'QueryBuilder',
  components: {
    QueryBuilderGroup,
  },
  props: {
    def: {
      type: Object,
      required: true,
    },
    filter: {
      type: String,
      requred: true,
    },
  },
  watch: {
    expression() {
      this.$emit('update:filter', this.expression);
    },
  },
  data() {
    return {
      expression: '',
      labels: {
        matchType: '',
        matchTypeAll: 'All of the following are true',
        matchTypeAny: 'One or more of the following are true',
        addAnalytic: 'Add Condition',
        removeAnalytic: '&times;',
        addGroup: 'Add Group',
        removeGroup: '&times;',
        textInputPlaceholder: 'value',
      },
    };
  },
};
</script>

<style lang="scss">
@import '@/scss/colors.scss';

pre.expression {
  background-color: $form-subitem;
  color: $font-color;
  border: 1px solid $border-color;
}
</style>
